export type OrbDefenseCell = 0 | 1 | 2;

export type OrbDefenseGridCell = {
  x: number;
  y: number;
  value: OrbDefenseCell;
};

export type OrbDefenseGridPoint = {
  x: number;
  y: number;
};

// Source: GameDefense `GameGrid2D`. 0 = path, 1 = wall, 2 = player/build space.
export const ORB_DEFENSE_GRID_ROWS = [
  "11111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111",
  "00000000000000000000000000000000000000012222210000000000000122222222100000000000000000000000122222210000000000012222100000000000122221000000000001222211111111111111111111111111",
  "00000000000000000000000000000000000000012222210000000000000122222222100000000000000000000000122222210000000000012222100000000000122221000000000001222211111111111111111111111111",
  "11111111111111111111111111000111111100012222210000000000000122222222100011111110001111111000122222210001111100012222100011111000122221000111110001222211100000111111110000011111",
  "12222222222222222222222221000122222100012222210001111111000122222222100012222210001222221000122222210001222100012222100012221000122221000122210001222211100000112222110000011111",
  "12222222222222222222222221000122222100012222210001222221000122222222100012222210001222221000122222210001222100012222100012221000122221000122210001222211100000112222110000011111",
  "12222222222222222222222221000122222100011111110001222221000111111111100012222210001222221000111111110001222100011111100012221000111111000122210001222211100000112222110000011111",
  "12222222222222222222222221000122222100000000000001222221000000000000000012222210001222221000000000000001222100000000000012221000000000000122210001222211100000112222110000011111",
  "12222222222222222222222221000122222100000000000001222221000000000000000012222210001222221000000000000001222100000000000012221000000000000122210001222211110001112222111000111111",
  "11111111111222221111111111000122222100000000000001222221000000000000000012222210001222221000000000000001222100000000000012221000000000000122210001222211110001112222111000111111",
  "00000000001222221000000000000122222100011111111111222221111111111111100012222210001222221111111111110001222111111111111112221111111111111111110001222211110001112222111000111111",
  "00000000001222221000000000000122222100012222222222222221111111112222100012222210001222221111111112210001222222222222222222222222222222111111110001111111110001112222111000111111",
  "00000000001222221000000000000122222100012222222222222221111111112222100012222210001222221111111112210001222222222222222222222222222222111111110000000000000001222222221000111111",
  "11111110001222221000111111111122222100012222222222222221111111112222100012222210001222221111111112210001222222222222222222222222222222111111110000000000000001222222221000111111",
  "12222210001222221000122222222222222100012222222222222221111111112222100012222210001222221111111112210001222222222222222222222222222222111111110000000000000001222222221000111111",
  "12222210001111111000122222222222222100012222222222222221111111112222100012222210001222221111111112210001222222222222222222222222222222111111111111111111111111222222221000111111",
  "12222210000000000000122221111111111100011111111111111111100000112222100012222210001111111100000112210001111111111111111111111222221111110000011222222222222222222222221000111111",
  "12222210000000000000122221000000000000000000000000000000000000112222100012222210000000000000000112210000000000000000000000001222221000000000011222222222222222222222221000111111",
  "12222210000000000000122221000000000000000000000000000000000000112222100012222210000000000000000112210000000000000000000000001222221000000000011222222222222222222222221000111111",
  "12222210001111111000122221000000000000000000000000000000000000112222100012222210000000000000000112210000000000000000000000001222221000000000011111111111111111111111111000111111",
  "12222210001222221000122221000111111111111111111111111111100000112222100012222210001111111100000112210001111111111111111110001222221000110000011000000000000000000000001000111111",
  "12222210001222221000122221000122222222222222222222222221111111112222100012222210001222221111111112210001222222222222222210001222221000111111111000000000000000000000001000111111",
  "12222210001222221000122221000122222222222222222222222221111111112222100012222210001222221111111112210001222222222222222210001111111000111111111000000000000000000000001000111111",
  "11111110001222221000111111000122222222222222222222222221111111112222100012222210001222221111111112210001222222222222222210000000000000111111111000111111111111111110001000111111",
  "00000000001222221000000000000122222222222222222222222221111111112222100012222210001222221111111112210001222222222222222210000000000000111111111000122222100000000000001000111111",
  "00000000001222221000000000000122222222222222222222222221111111112222100012222210001222221111111112210001222222222222222210000000000000111111111000122222100000000000001000111111",
  "00000000001222221000000000000122222111111111111111222221111111111111100012222210001222221111111111110001111111111111111111111111111111111111111000122222100000000000001000111111",
  "11111111111222221000111111111122222100000000000001222221000000000000000012222210001222221000000000000000000000000000000012222222222222222222221000122222100011111111111000111111",
  "12222222222222221000122222222222222100000000000001222221000000000000000012222210001222221000000000000000000000000000000012222222222222222222221000122222100012222222221000111111",
  "12222222222222221000122222222222222100000000000001222221000000000000000012222210001222221000000000000000000000000000000012222222222222222222221000122222100012222222221000111111",
  "12222222222222221000122222222222222100011111110001222221000111111111100012222210001222221000111111111111111111111111100012222222222222222222221000122222100012222222221000111111",
  "12222222222222221000122222222222222100012222210001222221000122222222100012222210001222221000122222222222222222222222100012222222222222222222221000122222100012222222221000111111",
  "12222222222222221000122222222222222100012222210001111111000122222222100012222210001222221000122222222222222222222222100012222222222222222222221000122222100012222222221000111111",
  "11111111111111111000111111111111111100012222210000000000000122222222100011111110001111111000122222222222222222222222100011111111111111111111111000122222100011111111111000111111",
  "00000000000000000000000000000000000000012222210000000000000122222222100000000000000000000000122222222222222222222222100000000000000000000000000000122222100000000000000000111111",
  "00000000000000000000000000000000000000012222210000000000000122222222100000000000000000000000122222222222222222222222100000000000000000000000000000122222100000000000000000111111",
  "11111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111122222111111111111111111111111",
] as const;

export const ORB_DEFENSE_GRID_HEIGHT = ORB_DEFENSE_GRID_ROWS.length;
export const ORB_DEFENSE_GRID_WIDTH = ORB_DEFENSE_GRID_ROWS[0].length;

export function getOrbDefenseCell(x: number, y: number): OrbDefenseCell {
  const value = ORB_DEFENSE_GRID_ROWS[y]?.[x];
  if (value !== "0" && value !== "1" && value !== "2") {
    throw new RangeError(`Orb Defense grid coordinate out of range: ${x},${y}`);
  }
  return Number(value) as OrbDefenseCell;
}

export function flattenOrbDefenseGrid(): OrbDefenseGridCell[] {
  const cells: OrbDefenseGridCell[] = [];
  for (let y = 0; y < ORB_DEFENSE_GRID_HEIGHT; y += 1) {
    for (let x = 0; x < ORB_DEFENSE_GRID_WIDTH; x += 1) {
      cells.push({ x, y, value: getOrbDefenseCell(x, y) });
    }
  }
  return cells;
}

export function getOrbDefenseTargets(): OrbDefenseGridPoint[] {
  const targets: OrbDefenseGridPoint[] = [];

  for (let y = 2; y < ORB_DEFENSE_GRID_HEIGHT - 2; y += 1) {
    for (let x = 2; x < ORB_DEFENSE_GRID_WIDTH - 2; x += 1) {
      let isTarget = true;

      for (let checkY = y - 2; checkY <= y + 2; checkY += 1) {
        for (let checkX = x - 2; checkX <= x + 2; checkX += 1) {
          if (getOrbDefenseCell(checkX, checkY) !== 0) {
            isTarget = false;
            break;
          }
        }
        if (!isTarget) {
          break;
        }
      }

      if (isTarget) {
        targets.push({ x, y });
      }
    }
  }

  return targets;
}

export function getOrbDefenseSpawnLocations(): OrbDefenseGridPoint[] {
  const spawns: OrbDefenseGridPoint[] = [];

  for (let y = 0; y < ORB_DEFENSE_GRID_HEIGHT; y += 1) {
    for (let x = 0; x < ORB_DEFENSE_GRID_WIDTH; x += 1) {
      const isBorder = x === 0 || x === ORB_DEFENSE_GRID_WIDTH - 1 || y === 0 || y === ORB_DEFENSE_GRID_HEIGHT - 1;
      if (isBorder && getOrbDefenseCell(x, y) === 0) {
        spawns.push({ x, y });
      }
    }
  }

  return spawns;
}
